module.exports = new __parcel__URL__("orange.ed5e97f9.svg").toString();